export function isSemanticSkinLabel(label) {
    return ['skin', 'face', 'faces', 'face_skin', 'body_skin', 'skin_tone', 'person_face'].includes(label.toLowerCase().replaceAll(/[\s-]+/g, '_'));
}
export function semanticSkinWeight(segmentation, nx, ny) {
    if (!segmentation)
        return undefined;
    const { width, height } = segmentation;
    if (!Number.isInteger(width) || !Number.isInteger(height) || width <= 0 || height <= 0 || !Array.isArray(segmentation.regions))
        return undefined;
    const index = Math.min(height - 1, Math.floor(ny * height)) * width +
        Math.min(width - 1, Math.floor(nx * width));
    let weight = 0;
    for (const region of segmentation.regions) {
        if (!isSemanticSkinLabel(region.label) || region.mask.length !== width * height)
            continue;
        const value = region.mask[index] ?? 0;
        weight = Math.max(weight, (value <= 1 ? value : value / 255) * Math.max(0, Math.min(1, region.confidence)));
    }
    return weight;
}
//# sourceMappingURL=semantic.js.map